export default __webpack_public_path__ + "static/media/headerIconPhone.5773024e.svg";